'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dnd = require('./dnd.info');

var _dnd2 = _interopRequireDefault(_dnd);

var _dnd3 = require('./dnd.endDnd');

var _dnd4 = _interopRequireDefault(_dnd3);

var _dnd5 = require('./dnd.endSnooze');

var _dnd6 = _interopRequireDefault(_dnd5);

var _dnd7 = require('./dnd.setSnooze');

var _dnd8 = _interopRequireDefault(_dnd7);

var _dnd9 = require('./dnd.teamInfo');

var _dnd10 = _interopRequireDefault(_dnd9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  info: _dnd2.default, endDnd: _dnd4.default, endSnooze: _dnd6.default, setSnooze: _dnd8.default, teamInfo: _dnd10.default
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/slack/methods/dnd.js
// module id = 427
// module chunks = 0